const WRAPPED_BLOCK_PATTERN =
  /<emergent-thinking>[\s\S]*?<\/emergent-thinking>\s*/;

export function hasManagedPromptBlock(content: string) {
  return WRAPPED_BLOCK_PATTERN.test(content);
}

export function upsertManagedPromptBlock(content: string, block: string) {
  const normalizedBlock = block.endsWith("\n") ? block : `${block}\n`;
  if (hasManagedPromptBlock(content)) {
    return content.replace(WRAPPED_BLOCK_PATTERN, normalizedBlock);
  }

  const trimmed = content.trimEnd();
  if (trimmed.length === 0) {
    return normalizedBlock;
  }
  return `${trimmed}\n\n${normalizedBlock}`;
}
